import { Badge, Collapse } from "reactstrap";
import { MessagesProfileData } from "../../../Data/Messenger/Messenger";
import { dynamicImage, Image } from "../../../Utils";
import { useState } from "react";

const Messages = () => {
  const [messages, setMessages] = useState(true);
  return (
    <div className="status">
      <div className="collapse-block open">
        <h5 className="block-title" onClick={() => setMessages(!messages)}>
          Starred Messages
          <Badge className="badge-outline-dark sm ms-2">2</Badge>
        </h5>
        <Collapse isOpen={messages} className="block-content">
          <div className="contact-chat p-0 m-0">
            <ul className="str-msg">
              {MessagesProfileData.map((item, index) => (
                <li key={index}>
                  <div className="d-flex gap-2">
                    <div className="profile me-4">
                      <Image className="bg-img img-fluid" src={dynamicImage(item.image)} alt="Avatar" />
                    </div>
                    <div className="flex-grow-1">
                      <div className="contact-name">
                        <h5>{item.title}</h5>
                        <h6>{item.time}</h6>
                        <ul className="msg-box">
                          <li><h5>{item.text}</h5></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default Messages;
